import { queryOptions, useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { ErrorState, Skeleton } from "~/components/ui/states";
import { companyQuery } from "~/features/sales/send-email";
import { DocumentTemplateForm } from "~/features/settings/document-template-form";
import { api, unwrap } from "~/lib/api";

export const Route = createFileRoute("/_app/settings/documents")({ component: DocumentsSettingsPage });

export const documentTemplateQuery = queryOptions({
  queryKey: ["settings", "document-template"],
  queryFn: () => unwrap(api.settings.company["document-template"].get()),
});

function DocumentsSettingsPage() {
  const template = useQuery(documentTemplateQuery);
  const company = useQuery(companyQuery);
  if (template.isPending || company.isPending) return <Skeleton className="h-[640px] w-full" />;
  if (template.isError) return <ErrorState error={template.error} onRetry={() => void template.refetch()} />;
  if (company.isError) return <ErrorState error={company.error} onRetry={() => void company.refetch()} />;
  // Keyed so a refetch after saving starts from the stored values.
  return <DocumentTemplateForm key={template.dataUpdatedAt} template={template.data} company={company.data} />;
}
